import { useLazyQuery, useQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Grid } from '@mui/material';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import moment from 'moment';
import toast from 'react-hot-toast';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import { PopoverModal } from '../../../../../components/popoverModal/PopoverModal';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import GET_COMBO_SUSPENSION_MOTIVO, { adaptComboSuspensionMotivoArray } from '../../../../../data/graphQL/queries/GestionAsistencial/getComboSuspensionMotivo';
import GET_COMBO_DETALLE_OBITO, { adaptComboDetalleObitoArray } from "../../../../../data/graphQL/queries/GestionAsistencial/getComboDetalleObito";
import GET_SUSPENSIONES, { adaptSuspensionesArray } from '../../../../../data/graphQL/queries/GestionAsistencial/getSuspensiones';
import { DELETE_SUSPENSION } from '../../../../../data/graphQL/mutations/GestionAsistencial/deleteSuspension';
import { CREATE_SUSPENSION } from '../../../../../data/graphQL/mutations/GestionAsistencial/createSuspension';
import { EDITAR_SUSPENSION } from '../../../../../data/graphQL/mutations/GestionAsistencial/editarSuspension';
import VALID_SUSPENSION from '../../../../../data/graphQL/queries/GestionAsistencial/validSuspension';

const SUSPSENSION_MOTIVO_OBITO = 16;
const SUSPENSION_MOTIVO_ALTA_NUTRICIONAL = 17;

export const Suspensiones = ({
  idPaciente,
  allowedWrite,
  idEvaluacionSelected,
  idDelegacion,
  getContratos,
  setSuspensionesAux,
  modulo,
  fechaHastaContrato
}) => {

  const [formData, setFormData] = useState({});
  const [idSuspension, setIdSuspension] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [motivosSuspension, setMotivosSuspension] = useState([]);
  const [detallesObito, setDetallesObito] = useState([]);
  const esModuloCP = useMemo(() => modulo?.toUpperCase().trim() === 'CP', [modulo]);

  const { data: dataComboSuspensionMotivo } = useQuery(GET_COMBO_SUSPENSION_MOTIVO);
  const { data: dataComboDetalleObito } = useQuery(GET_COMBO_DETALLE_OBITO);

  useEffect(() => {
    if (!dataComboSuspensionMotivo) return;
    setMotivosSuspension(adaptComboSuspensionMotivoArray(dataComboSuspensionMotivo?.comboSuspensionMotivo));
  }, [dataComboSuspensionMotivo]);

  useEffect(() => {
    if (!dataComboDetalleObito) return;
    setDetallesObito(adaptComboDetalleObitoArray(dataComboDetalleObito?.detalleObitos));
  }, [dataComboDetalleObito]);

  const {
    columns,
    suspensiones,
    totalCount,
    getSuspensiones
  } = useGetGrillaSuspensiones(motivosSuspension, idEvaluacionSelected, idPaciente, getContratos, setSuspensionesAux, setFormData, setIdSuspension);

  const [createSuspension] = useMutation(CREATE_SUSPENSION, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data?.createSuspension?.success) {
        toast.success("Se creó la suspensión correctamente");
        getSuspensiones({ variables: { idEvaluacion: idEvaluacionSelected } });
        getContratos({ variables: { idPaciente } });
        cleanForm();
        setIdSuspension(0);
      } else
        toast.error(data?.createSuspension?.error);
    }
  });

  const [editarSuspension] = useMutation(EDITAR_SUSPENSION, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data?.editarSuspension?.success) {
        toast.success("Se actualizó la suspensión correctamente");
        getSuspensiones({ variables: { idEvaluacion: idEvaluacionSelected } });
        getContratos({ variables: { idPaciente } });
        cleanForm();
        setIdSuspension(0);
      } else
        toast.error(data?.editarSuspension?.error);
    }
  });

  const [validateSuspension] = useLazyQuery(VALID_SUSPENSION, {
    fetchPolicy: 'no-cache'
  });

  const configuratedFields = useMemo(() => {
    return structuredClone(fields).
      map((input) => {
        const updatedInput = { ...input };
        switch (input.name) {
          case 'fechaDesde':
            updatedInput.disabled = idSuspension > 0;
            break;
          case 'fechaHasta':
            updatedInput.disabled = formData.idMotivoSuspension === SUSPSENSION_MOTIVO_OBITO || formData.idMotivoSuspension === SUSPENSION_MOTIVO_ALTA_NUTRICIONAL;
            break;
          case 'idMotivoSuspension':
            updatedInput.options = (idSuspension != 0 && formData.idMotivoSuspension != 16 && formData.idMotivoSuspension != undefined) ?
              motivosSuspension.filter((x) => x.displayName !== 'ÓBITO') :
              motivosSuspension;
            updatedInput.disabled = formData.idMotivoSuspension == 16 && idSuspension != 0; // obito
            break;
          case 'fechaObito':
            updatedInput.hidden = formData.idMotivoSuspension != 16 || !esModuloCP; // obito
            break;
          case 'idDetalleObito':
            updatedInput.options = detallesObito || [];
            updatedInput.hidden = formData.idMotivoSuspension != 16 || !esModuloCP;
            break;
          default:
            break;
        }
        if (!allowedWrite) {
          updatedInput.disabled = true;
        }
        return updatedInput;
      });
  }, [allowedWrite, motivosSuspension, idSuspension, formData.idMotivoSuspension, detallesObito, esModuloCP]);

  const motivoEsObito = useMemo(() => SUSPSENSION_MOTIVO_OBITO === formData.idMotivoSuspension, [formData.idMotivoSuspension]);

  const handleChange = (name, value) => {
    const extraFields = {};

    if (name === 'idMotivoSuspension') {
      if (value !== SUSPSENSION_MOTIVO_OBITO) {
        extraFields.fechaObito = null;
        extraFields.idDetalleObito = null;
      }
      if (value === SUSPSENSION_MOTIVO_OBITO || value === SUSPENSION_MOTIVO_ALTA_NUTRICIONAL) {
        extraFields.fechaHasta = fechaHastaContrato ? moment(fechaHastaContrato).format('YYYY-MM-DD') : null;
      }
    }

    setFormData((prev) => ({ ...prev, [name]: value, ...extraFields }));
  };

  const cleanForm = () => {
    setFormData((prev) => ({
      ...prev,
      fechaDesde: null,
      fechaHasta: null,
      idMotivoSuspension: null,
      observacion: '',
      fechaObito: null,
      idDetalleObito: null
    }));
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const isValid = async () => {
    const errorMessages = [];

    const { observacion, fechaDesde, fechaHasta, idMotivoSuspension } = formData;

    if (!observacion?.trim()) {
      errorMessages.push('Debe ingresar una Observación.\n');
    }
    if (!fechaDesde || !moment(fechaDesde).isValid()) {
      errorMessages.push('Debe ingresar una Fecha Desde válida.\n');
    }

    const fechaDesdeSinHs = moment(fechaDesde).format('YYYY-MM-DD');
    if (moment(fechaDesdeSinHs).isAfter(moment(fechaHasta))) {
      errorMessages.push('La Fecha Desde no puede ser superior a la Fecha Hasta.\n');
    }
    if (!fechaHasta || !moment(fechaHasta).isValid()) {
      errorMessages.push('Debe ingresar una Fecha Hasta válida.\n');
    }
    if (!idMotivoSuspension) {
      errorMessages.push('Debe ingresar un Motivo.\n');
    }

    if (esModuloCP && motivoEsObito && !formData.fechaObito) {
      errorMessages.push('Debe ingresar una Fecha de Óbito.\n');
    }

    if (esModuloCP && motivoEsObito && !formData.idDetalleObito) {
      errorMessages.push('Debe ingresar un Detalle de Óbito.\n');
    }

    try {
      const formattedFechaDesde = moment(fechaDesde).startOf('day').format('YYYY-MM-DD');
      const formattedFechaHasta = moment(fechaHasta).endOf('day').format('YYYY-MM-DD');

      const { data } = await validateSuspension({
        variables: {
          fechaDesde: formattedFechaDesde,
          fechaHasta: formattedFechaHasta,
          idEvaluacion: idEvaluacionSelected
        }
      });

      if (data?.validSuspension) {
        errorMessages.push(
          'No se puede cargar una suspensión ya que hay una conexión entre las fechas de suspensión.'
        );
      }
    } catch (error) {
      console.error('Error al validar la suspensión:', error);
      errorMessages.push('Ocurrió un error al validar la suspensión.');
    }

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  };

  const handleAgregarSuspension = async () => {
    const valid = await isValid();
    if (valid) {
      if (idSuspension == 0) handleOpenModal();
      else handleEditarSuspension();
    }
  };

  const handleEditarSuspension = async () => {
    editarSuspension({
      variables: {
        idSuspension: idSuspension,
        idEvaluacion: idEvaluacionSelected,
        idPaciente: idPaciente,
        soloContrato: false,
        idDelegacion: idDelegacion,
        idMotivo: formData.idMotivoSuspension,
        observacion: formData.observacion,
        fechaDesde: formData.fechaDesde,
        fechaHasta: formData.fechaHasta,
        fechaObito: formData.fechaObito,
        idDetalleObito: formData.idDetalleObito
      }
    });
  };

  const onAccept = () => {
    handleCloseModal();
    createSuspension({
      variables: {
        idSuspension: idSuspension,
        idEvaluacion: idEvaluacionSelected,
        idPaciente: idPaciente,
        soloContrato: false,
        idDelegacion: idDelegacion,
        idMotivo: formData.idMotivoSuspension,
        observacion: formData.observacion,
        fechaDesde: formData.fechaDesde,
        fechaHasta: formData.fechaHasta,
        fechaObito: formData.fechaObito,
        idDetalleObito: formData.idDetalleObito
      }
    });
  };
  const onAcceptContrato = () => {
    handleCloseModal();
    createSuspension({
      variables: {
        idSuspension: idSuspension,
        idEvaluacion: idEvaluacionSelected,
        idPaciente: idPaciente,
        idDelegacion: idDelegacion,
        soloContrato: true,
        idMotivo: formData.idMotivoSuspension,
        observacion: formData.observacion,
        fechaDesde: formData.fechaDesde,
        fechaHasta: formData.fechaHasta,
        fechaObito: formData.fechaObito,
        idDetalleObito: formData.idDetalleObito
      }
    });
  };
  const onAcceptPaciente = () => {
    handleCloseModal();
    createSuspension({
      variables: {
        idSuspension: idSuspension,
        idEvaluacion: idEvaluacionSelected,
        soloContrato: false,
        idPaciente: idPaciente,
        idDelegacion: idDelegacion,
        idMotivo: formData.idMotivoSuspension,
        observacion: formData.observacion,
        fechaDesde: formData.fechaDesde,
        fechaHasta: formData.fechaHasta,
        fechaObito: formData.fechaObito,
        idDetalleObito: formData.idDetalleObito
      }
    });
  };

  return (
    <div className='generic-tab-container container-separate'>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <div className='generic-header-tab-content-with-buttons'>
            <strong>Suspensiones</strong>
            <div className='button-save-geo-data'>
              <CustomButton
                onClick={handleAgregarSuspension}
                label={idSuspension == 0 ? 'Agregar suspensión' : 'Actualizar suspensión'}
                disabled={!allowedWrite}
                variant='outlined' />

            </div>
          </div>
        </Grid>
        <Grid container spacing={3} size="grow">
          {configuratedFields
            .filter(x => !x.hidden)
            .map((input, index) => {
              return (
                <Grid key={`input-${input.name}-index-${index}`} size={{ xs: 12, md: input.col }}>
                  <RenderInputByTypeMobile
                    key={`input-${input.name}-index-${index}`}
                    input={input}
                    handleChange={handleChange}
                    value={formData[input.name]} />

                </Grid>);

            })}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <DataGridGenerico
            toolbar={false}
            columns={columns}
            rows={suspensiones}
            totalCount={totalCount} />

        </Grid>
      </Grid>
      <CustomDialog
        title='Suspensión'
        open={openModal}
        fullWidth={true}
        maxWidth='sm'
        onCancel={handleCloseModal}
        onAccept={motivoEsObito ? onAccept : null}
        customActions={motivoEsObito ? null :
          <>
            <CustomButton
              label='Contrato'
              onClick={onAcceptContrato}
              variant='outlined' />

            <CustomButton
              label='Paciente'
              onClick={onAcceptPaciente}
              variant='outlined'
              disabled={moment(formData.fechaDesde).isBefore(moment().format('YYYY-MM-DD'))} />

          </>
        }>

        {!motivoEsObito ? <div>
          <p>¿Usted desea suspender solamente el contrato?</p>
          <p>Si presiona contrato solo se suspenderá el contrato de este paciente.</p>
          <p> Si presiona paciente usted suspenderá todos los contratos vigentes.</p>
        </div> :
          <div>
            <span>¿Usted desea suspender todos los contratos vigentes del paciente?</span>
          </div>
        }
      </CustomDialog>
    </div>);

};

const fields = [
  {
    displayName: 'Fecha desde',
    name: 'fechaDesde',
    type: 'date',
    col: 2
  },
  {
    displayName: 'Fecha hasta',
    name: 'fechaHasta',
    type: 'date',
    col: 2
  },
  {
    displayName: 'Motivo',
    name: 'idMotivoSuspension',
    type: 'select',
    col: 3
  },
  {
    displayName: 'Fecha Obito',
    name: 'fechaObito',
    type: 'date',
    col: 2
  },
  {
    displayName: 'Detalle Obito',
    name: 'idDetalleObito',
    type: 'select',
    col: 3
  },
  {
    displayName: 'Observación',
    name: 'observacion',
    type: 'long_string',
    col: 12
  }];


const useGetGrillaSuspensiones = (motivosSuspension, idEvaluacion, idPaciente, getContratos, setSuspensionesAux, setFormData, setIdSuspension) => {
  const [suspensiones, setSuspensiones] = useState([]);

  const [getSuspensiones, { data: dataSuspensiones }] = useLazyQuery(GET_SUSPENSIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataSuspensiones) return;
    setSuspensiones(adaptSuspensionesArray(dataSuspensiones?.suspencionesByIdEvaluacion));
    setSuspensionesAux(adaptSuspensionesArray(dataSuspensiones?.suspencionesByIdEvaluacion));
  }, [dataSuspensiones]);

  const [deleteSuspension] = useMutation(DELETE_SUSPENSION, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success("Se eliminó la suspension correctamente");
      getSuspensiones({ variables: { idEvaluacion } });
      getContratos({ variables: { idPaciente } });
      setIdSuspension(0);
    }
  });

  const handleDeleteSuspension = (row) => {
    const idSuspension = row.idSuspension;

    deleteSuspension({
      variables: { idSuspension, idEvaluacion },
      onError: () => {
        toast.error('Error eliminando la suspension.');
      }
    });
  };

  const handleEditSuspension = (row) => {
    setIdSuspension(row.idSuspension);

    setFormData((prev) => ({
      ...prev,
      fechaDesde: row.fechaDesde,
      fechaHasta: row.fechaHasta,
      idMotivoSuspension: row.idSuspensionMotivo,
      observacion: row.observaciones
    }));
  };

  const canEditSuspension = (row) => {
    const fechaActual = new Date();
    const fechaHasta = new Date(row.fechaHasta);
    const fechaHastaSinHora = new Date(fechaHasta.getFullYear(), fechaHasta.getMonth(), fechaHasta.getDate());
    const hoy = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate());

    if (fechaHastaSinHora.getTime() < hoy.getTime())
      return false;

    return true;
  };
  const hasObito = useMemo(() => suspensiones?.some((s) => s.fechaObito), [suspensiones]);

  const baseColumns = [
    {
      headerName: '',
      field: 'action',
      flex: 1,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                {canEditSuspension(row) &&
                  <div aria-hidden='true'
                    onClick={() => handleEditSuspension(row)}
                    className='item-option clickable-option'>
                    <EditIcon className='edit-icon' />
                    <span className='toggle-action'>Editar</span>
                  </div>
                }
                <div aria-hidden='true'
                  onClick={() => handleDeleteSuspension(row)}
                  className='item-option clickable-option'>
                  <DeleteOutlineIcon className='default-icon' />
                  <span className='toggle-action'>Eliminar</span>
                </div>
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      headerName: 'Id de suspensión',
      field: 'idSuspension',
      flex: 2
    },
    {
      headerName: 'F. Desde',
      field: 'fechaDesde',
      type: 'date',
      flex: 1.5
    },
    {
      headerName: 'F. Hasta',
      field: 'fechaHasta',
      type: 'date',
      flex: 1.5
    },
    {
      headerName: 'Motivo',
      field: 'idSuspensionMotivo',
      renderCell: ({ row }) => {
        return motivosSuspension?.find((x) => x.id === row.idSuspensionMotivo)?.displayName;
      },
      flex: 2
    },
    {
      headerName: 'Observación',
      field: 'observaciones',
      flex: 5
    },
    ...(hasObito ? [
      { headerName: 'Fecha Óbito', field: 'fechaObito', type: 'date', flex: 1.5 },
      { headerName: 'Detalle Óbito', field: 'detalleObito', flex: 1.5 }
    ] : []),
    {
      headerName: 'Fecha Alta',
      field: 'fechaAlta',
      type: 'date',
      flex: 1.5
    },
    {
      headerName: 'Usuario',
      field: 'usuario',
      flex: 1.5
    }];

  const columns = useMemo(() => generateColumnsDefaultConfiguration(baseColumns), [baseColumns, motivosSuspension, hasObito]);
  const totalCount = useMemo(() => suspensiones.length || 0, [suspensiones]);

  useEffect(() => {
    if (!idEvaluacion) return;
    getSuspensiones({ variables: { idEvaluacion } });
  }, [idEvaluacion, idPaciente]);

  return {
    columns,
    suspensiones,
    totalCount,
    getSuspensiones
  };
};